import { CONTACT_SERVICES, serviceHref } from "@/data/contact"

type LinkContext = {
  href: string
  origin: string
  pagePath: string
  location: string
  tracked?: boolean
  guideSlug?: string
}
export type LinkEvent = { name: string; params: Record<string, string> }

/** 許可したパス・IDだけを送る。URLの検索条件・入力値は解析へ渡さない。 */
export function linkEvents(context: LinkContext): LinkEvent[] {
  const target = new URL(context.href, context.origin)
  if (target.origin !== context.origin) return []
  if (target.pathname === "/contact") {
    const service = CONTACT_SERVICES.find(
      ({ id }) => id === target.searchParams.get("service"),
    )
    const params = {
      page_path: context.pagePath,
      service_id: service?.id ?? "all",
      form_type:
        target.searchParams.get("purpose") === "materials"
          ? "materials"
          : "consultation",
      cta_location: context.location,
    }
    return [
      // 既存の保存済みレポートで使うイベント名を継続する。
      { name: "contact_cta_click", params },
      ...(context.tracked
        ? []
        : [
            {
              name: "cta_click",
              params: { ...params, destination: "contact_form" },
            },
          ]),
    ]
  }
  const service = CONTACT_SERVICES.find(({ id }) => {
    const page = new URL(serviceHref(id), context.origin)
    return page.hash
      ? target.pathname === page.pathname && target.hash === page.hash
      : target.pathname === page.pathname ||
          target.pathname.startsWith(`${page.pathname}/`)
  })
  if (
    !service ||
    !context.guideSlug ||
    context.pagePath !== `/guides/${context.guideSlug}`
  )
    return []
  return [
    {
      name: "guide_service_click",
      params: {
        slug: context.guideSlug,
        service_id: service.id,
        destination_path: target.pathname,
        cta_location: context.location,
      },
    },
  ]
}
